










































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import meterModelPo from "@/store/entities/devices/switchs/switchmodelpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "@/lib/util";

@Component({
  components: { TreeSelect },
})
export default class EditSwitchModel extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  meterModelPo: meterModelPo = new meterModelPo();
  loading: boolean = false;
  created() {
    this.areaTree();
    this.getItemDetail();
    this.getOrganizations();
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      detaillist.forEach((ele) => {
        if (ele.itemId == 13) {
          this.$data.transferType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 3) {
          this.$data.ispType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 5) {
          this.$data.potocolType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 17) {
          this.$data.deviceType.push({ label: ele.name, value: ele.id });
        }
      });
    }
  }
  //获取组织
  async getOrganizations() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.organizations = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //保存
  save() {
    (this.$refs.meterModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "switchmodel/update",
            data: this.meterModelPo,
          })
          .catch(() => {
            this.loading = false;
          });
        (this.$refs.meterModelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.meterModelForm as any).resetFields();

    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.meterModelPo = Util.extend(true, {}, this.$store.state.switchmodel.switchModelItems);
    }
  }
  //规则
  modelRule = {
    organizationId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    transferType: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "change",
      },
    ],
    protocol: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    isp: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceTypeId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  //区域
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      arealist: [], //区域
      transferType: [], //传输
      ispType: [], //运营商
      potocolType: [], //协议
      deviceType: [], //设备类型
      organizations: [], //组织
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
